import { ref } from 'vue';

export const useClipboard = () => {
    const showSnackbar = ref(false);

    const copyToClipboard = async (text: string) => {
        await navigator.clipboard.writeText(text);
        showSnackbar.value = true;
    };

    return { showSnackbar, copyToClipboard };
};
